import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=b5a002c2&scoped=true"
import script from "./Scan.vue?vue&type=script&lang=js"
export * from "./Scan.vue?vue&type=script&lang=js"
import style0 from "./Scan.vue?vue&type=style&index=0&id=b5a002c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a002c2",
  null
  
)

export default component.exports